<template>
  <form class="userList">
    <div v-if="hashId" class="userList__checkbox form-check" v-for="option in currentCheckedList" :key="option.hash_id">
      <label class="userList__label">
        <input class="userList__input" type="checkbox" v-model="listItems" :value="option.hash_id" :checked="option.checked" @change="onChange">
        {{ option.name }}
      </label>
    </div>
    <div v-if="!hashId" class="userList__checkbox form-check" v-for="option in currentCheckedList" :key="option.id">
      <label class="userList__label">
        <input class="userList__input" type="checkbox" v-model="listItems" :value="option.id" :checked="option.checked" @change="onChange">
        {{ option.name }}
      </label>
    </div>
  </form>
</template>

<script>
import Checkbox from '@/components/Form/Checkbox/checkbox'

import {map, contains} from 'ramda'

export default {
  name: 'List',
  components: {
    Checkbox
  },
  props: {
    data: Array,
    currentIds: {
      type: [Number, Array],
      default: () => []
    },
    hashId: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    'currentIds': function (newVal) {
      if (this.currentIds) {
        this.listItems = newVal
      }
    }
  },
  created () {
    if (this.currentIds) {
      this.listItems = this.currentIds
    }
  },
  data: () => ({
    listItems: []
  }),
  computed: {
    currentCheckedList () {
      const checked = item => {
        let id
        if (this.hashId) {
          id = item.hash_id
        } else {
          id = item.id
        }
        return {
          ...item,
          checked: contains(id, this.currentIds)
        }
      }
      return map(checked, this.data)
    }
  },
  methods: {
    onChange () {
      this.$emit('input', this.listItems)
    }
  }
}
</script>

<style lang="scss">
    @import "list";
</style>



// WEBPACK FOOTER //
// src/components/List/list.vue